import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { Building2, User, Phone, Mail, MapPin, Globe, Map } from "lucide-react";


interface GeneralInfoStepProps {
  form: UseFormReturn<any>;
}

const GeneralInfoStep = ({ form }: GeneralInfoStepProps) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold flex items-center gap-2">
          <Building2 className="w-6 h-6 text-primary" />
          Informazioni Generali
        </h2>
        <p className="text-muted-foreground">Iniziamo con i dati fondamentali del tuo centro estetico</p>
      </div>

      <FormField
        control={form.control}
        name="centerName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nome del Centro Estetico *</FormLabel>
            <FormControl>
              <Input placeholder="Es. Beauty Center Milano" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="ownerName"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <User className="w-4 h-4" />
              Nome e Cognome del Titolare *
            </FormLabel>
            <FormControl>
              <Input placeholder="Es. Maria Rossi" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid md:grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="phoneNumber"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                Numero di telefono del centro *
              </FormLabel>
              <FormControl>
                <Input placeholder="+39 333 1234567" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                Indirizzo Email *
              </FormLabel>
              <FormControl>
                <Input type="email" placeholder="info@tuocentro.it" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="address"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <MapPin className="w-4 h-4" />
              Indirizzo del centro *
            </FormLabel>
            <FormControl>
              <Input placeholder="Es. Via Roma 123" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid md:grid-cols-3 gap-4">
        <FormField
          control={form.control}
          name="city"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Città del centro *</FormLabel>
              <FormControl>
                <Input placeholder="Es. Milano" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="province"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Provincia del centro *</FormLabel>
              <FormControl>
                <Input placeholder="Es. MI" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="zipCode"
          render={({ field }) => (
            <FormItem>
              <FormLabel>CAP del centro *</FormLabel>
              <FormControl>
                <Input placeholder="Es. 20121" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="googleMapsLink"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <Map className="w-4 h-4" />
              Link Google Maps del centro
            </FormLabel>
            <FormControl>
              <Input placeholder="https://maps.google.com/?q=..." {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="website"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <Globe className="w-4 h-4" />
              Sito Web
            </FormLabel>
            <FormControl>
              <Input placeholder="https://www.tuocentro.it" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="landmarks"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Punti di Riferimento vicino al centro</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Es. Accanto alla farmacia comunale, di fronte al parco..."
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

    </div>
  );
};

export default GeneralInfoStep;
